import React from "react";
import { FaLongArrowAltRight } from "@react-icons/all-files/fa/FaLongArrowAltRight";

const MyButton = ({ text, onClick, className = "" }) => {
  const style =
    "bg-orange-500 text-white px-4 py-[12px] rounded-full flex gap-2 items-center text-sm sm:text-xl lg:text-lg font-bold hover:bg-[#034C8C]";
  return (
    <div>
      <button onClick={onClick} className={`${style} ${className}`}>
        {text} <FaLongArrowAltRight />
      </button>
    </div>
  );
};

export default MyButton;
